
const loadCaptchaGoogleV2 = () => import('captcha_google_v2').then(module => module.default);
export const google_v2_captcha = loadCaptchaGoogleV2
const loadRenderMarkdownCodehighlight = () => import('render-markdown-codehighlight').then(module => module.default);
export const render_markdown_codehighlight = loadRenderMarkdownCodehighlight